/**
 * H3 Configuration for spatial indexing
 * Re-exports shared config with TypeScript types
 */

import h3ConfigImport from '../shared/h3-config';

export interface H3Config {
  resolutions: number[];
  BASE_RESOLUTION: number;
  zoomToResolutionMap: Array<{
    maxZoom: number | null;
    filterRes: number | null;
    aggRes: number | null;
  }>;
  getSettingsForZoom: (zoom: number) => {
    filterRes: number | null;
    aggRes: number | null;
  };
  getColumnName: (resolution: number) => string;
  getAllColumnNames: () => string[];
  getBaseResolution: () => number;
  getNextResolution: (resolution: number) => number | null;
}

export const H3_CONFIG = h3ConfigImport as unknown as H3Config;

export const getSettingsForZoom = (h3ConfigImport as any).getSettingsForZoom.bind(h3ConfigImport);
